import React, { useEffect, useMemo } from 'react'
import { Slider, Text, View } from '@/components'
import { SliderComposition, StylesOf } from '@codeleap/common'

type TrackMarkStyle = {
  fontSize ?: number
  color ?: string
  fontWeight ?: number | string
}

type SliderOnboardingProps = {
  label?: string
  labelVariants?: string[]
  min: number
  max: number
  trackMarks?: Record<number, string>
  trackMarkStyle?: TrackMarkStyle
  value?: number
  defaultValue?: number
  onValueChange?: (val: number) => void
}

export function SliderOnboarding(props: SliderOnboardingProps) {
  const { label, min, max, value, defaultValue = 3, onValueChange, trackMarkStyle, ...rest } = props
  
  const customTrackMarkStyles = useMemo(() => ({
    trackMark: {
      fontSize: trackMarkStyle?.fontSize,
      color: trackMarkStyle?.color,
      fontWeight: trackMarkStyle?.fontWeight,
    },
  }), [trackMarkStyle])

  useEffect(() => {
    onValueChange(defaultValue)
  }, [])
  const steps = Array.from({ length: max - min + 1 }, (_, i) => i + min)

  if (min == null || max == null) return null

  return (
    <View variants={['fullWidth', 'column']}>
      {label && <Text variants={['p2', 'color:neutral5', 'marginBottom:4']} text={label} />}

      <View variants={['row', 'justifySpaceBetween', 'paddingHorizontal:1.25']}>
        {steps.map(n => (
          <Text key={n} variants={['p4', 'color:neutral9']} text={String(n)} />
        ))}
      </View>

      <Slider
        {...rest}
        value={[value ?? defaultValue]}
        onValueChange={(value: number[]) => onValueChange(value?.[0])}
        min={min}
        max={max}
        step={1}
        debugName='onboarding-slider'
        variants={['onboarding']}
        styles={customTrackMarkStyles}
      />
    </View>
  )
}
